(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDeleteController',ProgramaEducativoDeleteController);

    ProgramaEducativoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDeleteController($uibModalInstance, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgramaEducativo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
